import { useEffect, useState, useRef } from 'react'
import { motion, useInView } from 'framer-motion'

const stats = [
  { value: 13, suffix: '', label: 'Compliance rules seeded live' },
  { value: 28, suffix: '/28', label: 'Passing tests, deterministic Attribution engine' },
  { value: 6, suffix: '', label: 'Human-review queue types for ambiguous AI decisions' },
  { value: 32, suffix: '', label: 'Automated access-control tests' },
]

function AnimatedNumber({ value, suffix = '', duration = 2 }) {
  const [displayValue, setDisplayValue] = useState(0)
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })
  
  useEffect(() => {
    if (!isInView) return
    
    let start = 0
    const end = value
    const incrementTime = (duration * 1000) / end
    
    const timer = setInterval(() => {
      start += Math.ceil(end / 50)
      if (start >= end) {
        setDisplayValue(end)
        clearInterval(timer)
      } else {
        setDisplayValue(start)
      }
    }, incrementTime)
    
    return () => clearInterval(timer)
  }, [value, duration, isInView])
  
  return (
    <span ref={ref}>
      {Number.isInteger(displayValue) ? displayValue : displayValue.toFixed(1)}
      {suffix}
    </span>
  )
}

export default function StatsSection() {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-void-950 via-synth-950/10 to-void-950" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-gradient mb-2">
                <AnimatedNumber value={stat.value} suffix={stat.suffix} />
              </div>
              <p className="text-void-400 text-sm md:text-base">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
